import { useState } from 'react';

// Menú «⋯» compacto para acciones secundarias de una tarjeta.
export default function RowMenu({ items }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="relative">
      <button type="button" onClick={() => setOpen(!open)} aria-label="Más acciones"
        className="w-9 h-9 flex items-center justify-center rounded-xl text-gray-400 hover:bg-gray-100 text-lg leading-none">⋯</button>
      {open && <>
        <div className="fixed inset-0 z-20" onClick={() => setOpen(false)} />
        <div className="absolute right-0 top-10 z-30 w-52 bg-white rounded-2xl shadow-lg border border-gray-100 py-1.5">
          {items.map(({ label, onClick, danger }) => (
            <button key={label} type="button" onClick={() => { setOpen(false); onClick(); }}
              className={`w-full text-left px-4 py-2.5 text-sm hover:bg-gray-50 ${danger ? 'text-red-600' : 'text-gray-700'}`}>{label}</button>
          ))}
        </div>
      </>}
    </div>
  );
}
